import React, { Fragment } from 'react'
import { Row, Col } from 'react-bootstrap'
import moment from 'moment'

const formatTransactionDate = (value) => {
  if (!value) return ''
  const parsed = moment(value, [moment.ISO_8601, 'MMM D, YYYY', 'MMM DD, YYYY'], true)
  if (parsed.isValid()) return parsed.format('lll')
  const fallback = new Date(value)
  return Number.isNaN(fallback.getTime()) ? '' : moment(fallback).format('lll')
}

const TransactionDetails = (props) => {
  const selectedItem = props.selectedItem || {}
  const paymentGateway = selectedItem.payment_gateway || {}
  const parent = selectedItem.parent || {}
  const user = selectedItem.user || {}
  const athlete = selectedItem.athlete || {}
  const program = selectedItem.program || {}
  const programs = Array.isArray(selectedItem.programs) ? selectedItem.programs : []
  var EF3 = !Object.prototype.hasOwnProperty.call(selectedItem, 'programs')

  if (!EF3) {
    let EF2_status = Array.isArray(paymentGateway.status) ? paymentGateway.status : []
    var EF2_date = EF2_status.length ? EF2_status[EF2_status.length -1].timestamp : selectedItem.create_date
    var EF2_time = formatTransactionDate(EF2_date)
  }

  return (
    <Fragment>
      <Col lg={12} xs={12} className="transaction-details">
        <Row className="form-group">
           <Col lg={3} sm={4}>{EF3 ? 'Parent:' : 'Account Holder:'}</Col>
           <Col lg={9} sm={8} className="less-bold-text">
             {
                EF3 ?
                `${parent.first_name || ''} ${parent.last_name || ''}`
                :
                `${user.first_name || ''} ${user.last_name || ''}`
             }
           </Col>
         </Row>
        {
          EF3 &&
          <Row className="form-group">
            <Col lg={3} xs={6}>Player</Col>
            <Col lg={9} xs={6}>
              {athlete.first_name || ''} {athlete.last_name || ''}
            </Col>
          </Row>
        }
        <Row className="form-group">
          {
            EF3 ?
            <Fragment>
              <Col lg={3} xs={6}>Program</Col>
              <Col lg={9} xs={6}>
                {program.group_name || 'Transaction'} {selectedItem.team_name&& `[ ${selectedItem.team_name} ]`}
              </Col>
            </Fragment>
            :
            <Fragment>
              {
                programs.map((program, index) => {
                  return (
                    <Fragment>
                      <Col xs={6}>{index === 0 ? 'Programs': ''}</Col>
                      <Col xs={6}>{program.name}</Col>
                    </Fragment>
                  )
                })
              }
            </Fragment>
          }
        </Row>
        <Row className="form-group">
          <Col lg={3}  xs={6}>Created</Col>
          <Col lg={9}  xs={6}>
          {
            paymentGateway.receipt ?
              EF3 ? formatTransactionDate(selectedItem.create_date) : `${EF2_time}`
            :
            formatTransactionDate(selectedItem.create_date)
          }      
          </Col>
        </Row>
        {
          paymentGateway.receipt &&
            <Row className="form-group">
              <Col sm={4}>Credit Card</Col>
              <Col sm={8}>{paymentGateway.receipt.ssl_card_short_description || ''} {paymentGateway.receipt.ssl_card_number ? paymentGateway.receipt.ssl_card_number.slice(-4) : ''}</Col>
            </Row>
        }
      </Col> 
    </Fragment>
  )
}

export default TransactionDetails
